"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _react2 = require("@iconify/react");
var _bxlFacebook = _interopRequireDefault(require("@iconify-icons/bx/bxl-facebook"));
var _bxlInstagram = _interopRequireDefault(require("@iconify-icons/bx/bxl-instagram"));
var _bxlTwitter = _interopRequireDefault(require("@iconify-icons/bx/bxl-twitter"));
var _bxlYoutube = _interopRequireDefault(require("@iconify-icons/bx/bxl-youtube"));
var _bxlVimeo = _interopRequireDefault(require("@iconify-icons/bx/bxl-vimeo"));
var _bxlWhatsapp = _interopRequireDefault(require("@iconify-icons/bx/bxl-whatsapp"));
var _bxlPinterest = _interopRequireDefault(require("@iconify-icons/bx/bxl-pinterest"));
var _bxlBlogger = _interopRequireDefault(require("@iconify-icons/bx/bxl-blogger"));
var _bxlFlickr = _interopRequireDefault(require("@iconify-icons/bx/bxl-flickr"));
var _bxlLinkedin = _interopRequireDefault(require("@iconify-icons/bx/bxl-linkedin"));
var _bxFolderOpen = _interopRequireDefault(require("@iconify-icons/bx/bx-folder-open"));
var _tiktok = _interopRequireDefault(require("@iconify-icons/cib/tiktok"));
var _appContext = _interopRequireDefault(require("../../context/appContext"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    width: "100%"
  },
  list: {
    alignItems: "center",
    display: "flex",
    flexWrap: "wrap"
  },
  iconItem: {
    alignItems: "center",
    background: theme.palette.background.socialMediaItem,
    borderRadius: "50%",
    boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.15)",
    color: theme.palette.foreground.socialMediaItem,
    display: "flex",
    height: 35,
    justifyContent: "center",
    lineHeight: 1,
    margin: theme.spacing(0, 0.75, 0, 0),
    transition: theme.transitions.create(["all"]),
    width: 35,
    "&:hover": {
      background: theme.palette.primary.main,
      color: theme.palette.common.white
    },
    "&:last-child": {
      marginRight: 0
    },
    "& svg": {
      display: "block",
      lineHeight: 1
    }
  }
}));
const SocialLinks = () => {
  const [appData] = (0, _react.useContext)(_appContext.default);
  const css = useStyles();
  if (!(0, _lodash.isEmpty)(appData === null || appData === void 0 ? void 0 : appData.links)) {
    const listItems = appData.links.map((item, counter) => {
      return /*#__PURE__*/_react.default.createElement("a", {
        className: css.iconItem,
        key: counter,
        href: item.url,
        target: "_blank",
        rel: "noreferrer",
        "data-type": item.type
      }, /*#__PURE__*/_react.default.createElement(GetIcon, {
        type: item.type
      }));
    });
    return /*#__PURE__*/_react.default.createElement(_core.Box, {
      className: css.list
    }, listItems);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};
const GetIcon = props => {
  const {
    type
  } = props;
  const css = useStyles();
  switch (type) {
    case "facebook":
      return /*#__PURE__*/_react.default.createElement(_react2.Icon, {
        className: css.icon,
        height: "24",
        icon: _bxlFacebook.default
      });
    case "instagram":
      return /*#__PURE__*/_react.default.createElement(_react2.Icon, {
        className: css.icon,
        height: "24",
        icon: _bxlInstagram.default
      });
    case "twitter":
      return /*#__PURE__*/_react.default.createElement(_react2.Icon, {
        className: css.icon,
        height: "24",
        icon: _bxlTwitter.default
      });
    case "youtube":
      return /*#__PURE__*/_react.default.createElement(_react2.Icon, {
        className: css.icon,
        height: "24",
        icon: _bxlYoutube.default
      });
    case "vimeo":
      return /*#__PURE__*/_react.default.createElement(_react2.Icon, {
        className: css.icon,
        height: "24",
        icon: _bxlVimeo.default
      });
    case "pinterest":
      return /*#__PURE__*/_react.default.createElement(_react2.Icon, {
        className: css.icon,
        height: "24",
        icon: _bxlPinterest.default
      });
    case "blog":
      return /*#__PURE__*/_react.default.createElement(_react2.Icon, {
        className: css.icon,
        height: "24",
        icon: _bxlBlogger.default
      });
    case "flickr":
      return /*#__PURE__*/_react.default.createElement(_react2.Icon, {
        className: css.icon,
        height: "18",
        icon: _bxlFlickr.default
      });
    case "linkedin":
      return /*#__PURE__*/_react.default.createElement(_react2.Icon, {
        className: css.icon,
        height: "24",
        icon: _bxlLinkedin.default
      });
    case "tiktok":
      return /*#__PURE__*/_react.default.createElement(_react2.Icon, {
        className: css.icon,
        height: "20",
        icon: _tiktok.default
      });
    case "whatsapp":
      return /*#__PURE__*/_react.default.createElement(_react2.Icon, {
        className: css.icon,
        height: "24",
        icon: _bxlWhatsapp.default
      });
    case "website":
      return /*#__PURE__*/_react.default.createElement(_react2.Icon, {
        className: css.icon,
        height: "24",
        icon: _bxFolderOpen.default
      });
    default:
      return null;
  }
};
var _default = exports.default = SocialLinks;